import {Email, Lang, PersonId} from "@/sdk.ts";

export class PersonMe {
  readonly public_id: PersonId;
  email: Email;
  first_name: string;
  last_name: string;
  lang?: Lang;
  is_verified: boolean;

  constructor(props) {
    this.public_id = props.public_id;
    this.email = props.email;
    this.first_name = props.first_name;
    this.last_name = props.last_name;
    this.lang = props.lang;
    this.is_verified = props.is_verified;
  }

  update(props) {

  }

  public get initials(){
    return this.first_name[0] + this.last_name[0]
  }
}
